<app-modal
  header="Browse Specialties"
  [width]="width"
  height="600px"
  [(visible)]="isModalOpen"
  (afterClose)="closeModel()"
>
  <div class="browse-specialties__sub-nav" data-test="specialtyModalTab">
    <app-toggle
      [options]="tabOptions"
      [value]="selectedTab"
      variant="secondary"
      (change)="changeTab($event.value)"
    />
  </div>

  <div
    class="specialties-container"
    [class.hide-section]="selectedTab === 'Fellowships'"
    data-test="residencies-container"
  >
    @for (specialty of residencies(); track specialty.nid) {
      <div class="specialty-item">
        <app-checkbox
          [label]="specialty.name"
          [checked]="specialty.isChecked"
          (checkChange)="onSpecialtySelected($event, specialty)"
        />
      </div>
    }
  </div>

  <div
    class="specialties-container"
    [class.hide-section]="selectedTab === 'Residencies'"
    data-test="fellowships-container"
  >
    @for (specialty of fellowships(); track specialty.nid) {
      <div class="specialty-item">
        <app-checkbox
          [label]="specialty.name"
          [checked]="specialty.isChecked"
          (checkChange)="onSpecialtySelected($event, specialty)"
        />
      </div>
    }
  </div>

  <ng-template modalFooter>
    <div class="browse-specialties__footer">
      @if (selectedSpecialties().length > 0) {
        <p class="browse-specialties__footer__count">{{ selectedSpecialties().length }} {{ selectedSpecialties().length === 1 ? 'Specialty' : 'Specialties' }} Selected</p>
      }
      <app-button
        label="Search"
        [variant]="canSearch ? 'primary' : 'secondary'"
        [disabled]="!canSearch"
        (clicked)="onSearchClicked()"
        data-test="modal-search-button"
      />
    </div>
  </ng-template>
</app-modal>
